
import { saveAs } from "file-saver";

export function exportToCsv({ headers, rows, fileName }) {
  const csvRows = rows.map((row) =>
    row.map((value) => `"${value ?? "N/A"}"`).join(",")
  );
  const csvContent = `${headers.join(",")}\n${csvRows.join("\n")}`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `${fileName}.csv`);
}

export function exportNestedToCsv({ headers, data, getMainValues, getNestedValues, fileName }) {
  const rows = data.flatMap((row) => {
    const main = getMainValues(row);
    const nested = row.additionalData;
    const emptyNested = Array(headers.length - main.length).fill("");
    if (nested && nested.length > 0) {
      return nested.map((n) =>
        [...main, ...getNestedValues(n)].map((v) => `"${v ?? ""}"`).join(",")
      );
    }
    return [[...main, ...emptyNested].map((v) => `"${v}"`).join(",")];
  });
  const csvContent = `${headers.join(",")}\n${rows.join("\n")}`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `${fileName}.csv`);
}

const HEADER_STYLE = {
  fill: { patternType: "solid", fgColor: { rgb: "C72127" } },
  font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  border: {
    top:    { style: "thin", color: { rgb: "000000" } },
    bottom: { style: "thin", color: { rgb: "000000" } },
    left:   { style: "thin", color: { rgb: "000000" } },
    right:  { style: "thin", color: { rgb: "000000" } },
  },
};

const DATA_STYLE = {
  fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } },
  font: { color: { rgb: "2D3748" }, sz: 11 },
  alignment: { horizontal: "left", vertical: "center", wrapText: true },
  border: {
    top:    { style: "thin", color: { rgb: "000000" } },
    bottom: { style: "thin", color: { rgb: "000000" } },
    left:   { style: "thin", color: { rgb: "000000" } },
    right:  { style: "thin", color: { rgb: "000000" } },
  },
};

export async function exportToExcel({ headers, fields, data, sheetName = "Report", fileName = "report" }) {
  const XLSX = await import("xlsx-js-style");
  const wsData = [
    headers.map((h) => ({ v: h, t: "s", s: HEADER_STYLE })),
    ...data.map((row) =>
      fields.map((f) => ({
        v: row[f] !== undefined && row[f] !== null ? String(row[f]) : "",
        t: "s",
        s: DATA_STYLE,
      }))
    ),
  ];

  const ws       = XLSX.utils.aoa_to_sheet(wsData);
  ws["!cols"]    = headers.map(() => ({ wch: 20 }));
  ws["!rows"]    = [{ hpt: 30 }, ...data.map(() => ({ hpt: 22 }))];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${fileName}.xlsx`
  );
}